import { IIndicatorResponse } from '@kcftech/prometheus-client';
import { TimeMarkerId } from 'pages/workbench/workbench_tabs/trend/types';
import { TimeRange } from 'utils/types';

export type FrequencyScale = 'linear' | 'log';
export type BurstDataType = 'velocity' | 'acceleration';
export type SidebandCount = 1 | 2 | 3 | 4 | 5;
export type SecondaryChartType = 'frequency' | 'time';

/**
 * Options for Off Threshold selections
 */
export type OffThresholdClassification = 'Set' | 'Inherit' | 'Unset' | 'None';

export type IndicatorFilterTabType = 'custom' | 'type';
export type IndicatorSelectionMode = 'manual' | 'auto';

export type SelectedPoint = {
    xValue: number;
    seriesId: string;
};

export type SelectedSeriesPoint = SelectedPoint & {
    isDownsampled: boolean;
};

export type WaterfallSelectedPoint = SelectedSeriesPoint &
    Readonly<{
        indicatorId: string;
    }>;

export type ActivityFilters = {
    categoryFilterIds: number[];
    alertFilterIds: number[];
    automaticFilterIds: number[];
    machineIQFilterIds: number[];
};

export type IndicatorInfo = {
    indicatorId: string;
    color: string;
};

export type IndicatorAndColorInfo = Readonly<{
    hierarchy: string;
    indicatorId?: string;
    dataPlatformIndicatorId?: string;
    color: string;
}>;

export type LoadedIndicatorAndColorInfo = IndicatorAndColorInfo &
    Readonly<{ indicator?: IIndicatorResponse }>;

export type UnifiedChartMetadata = Readonly<{
    indicators: LoadedIndicatorAndColorInfo[];
    timeRange: TimeRange;
    selectedPoint?: SelectedSeriesPoint;
    frequencyBurstDataType?: BurstDataType;
    timeBurstDataType?: BurstDataType;
    waterfallBurstDataType?: BurstDataType;
    waterfallFrequencyPoints?: SelectedSeriesPoint[];
}>;

export const MarkerModes = ['Electrical', 'Vibration'] as const;
export type MarkerMode = (typeof MarkerModes)[number];

export type TimeMarkerMeta = Readonly<{
    id: TimeMarkerId;
    zeroCycleMs: number;
    visible: boolean;
}>;
